<template>

	<div class="container_page">
		<div class="title">工厂首页</div>
		<div style="margin-bottom: 20px;">
			<span style="color: #f00;">*</span>
			<span class="titleSu">筛选项</span>
		</div>
		<a-row>
			<a-col :xs="24" :sm="24" :md="10">
				<div style="display: flex;">
					<a-select style="width: 100%;" class="mr12" placeholder="请选择筛选项" show-search
						option-filter-prop="name" :filter-option="filterOption" v-model="filterData.factoryId">
						<a-select-option v-for="(item, index) of factoryList.filter(f => !factoryData.some(d => d.tagCategoryId === f.tagCategoryId))" :key="index" :value="item.tagCategoryId">
							{{ item.tagCategoryName }}
						</a-select-option>
						<a-select-option v-if="!factoryData.some(d => d.searchType === 'AREA')" value="AREA">区域</a-select-option>
					</a-select>
					<a-button style="width: 100px;margin-left: 20px;" type="primary" @click="addFactory">+ 新增</a-button>
				</div>

				<div ref="dragContainer" style="width: 100%;">
					<div class="size_item mr12" style="width: 100%;" v-for="(item, index) of factoryData" :key="item.tagCategoryId">
						<span class="left">{{ item.tagCategoryName }}</span>
						<div class="right" @click="deletePaperSizeFactory(index)">
							<a-icon :style="{ fontSize: '20px', color: '#f00' }" type="delete" />
						</div>
					</div>
				</div>



				<div style="width: 100%;height: 40px;">
					<div v-if="requiredFactory&&factoryData.length == 0" style="color: #f00;font-size: 14px;"
						class="factory">请填写筛选项</div>
					<div v-if="lessThanTwoFactory&&factoryData.length < 2" style="color: #f00;font-size: 14px;"
						class="factory">至少添加2个筛选项</div>
				</div>


			</a-col>
		</a-row>
		<div class="title">品牌首页</div>
		<div style="margin-bottom: 20px;">
			<span style="color: #f00;">*</span>
			<span class="titleSu">筛选项</span>
		</div>
		<a-row>
			<a-col :xs="24" :sm="24" :md="10">
				<div style="display: flex;">
					<a-select style="width: 100%;" class="mr12" placeholder="请选择筛选项" show-search
						option-filter-prop="name" :filter-option="filterOption" v-model="filterData.brandId">
						<a-select-option v-for="(item, index) of brandsList.filter(f => !brandsData.some(d => d.tagCategoryId === f.tagCategoryId))" :key="index" :value="item.tagCategoryId">
							{{ item.tagCategoryName }}
						</a-select-option>
					</a-select>
					<a-button style="width: 100px;margin-left: 20px;" type="primary" @click="addBrand">+ 新增</a-button>
				</div>
				<div ref="dragContainerBrand" style="width: 100%;">
					<div class="size_item mr12" style="width: 100%;" v-for="(item, index) of brandsData" :key="item.tagCategoryId">
						<span class="left">{{ item.tagCategoryName }}</span>
						<div class="right" @click="deletePaperSizeBrand(index)">
							<a-icon :style="{ fontSize: '20px', color: '#f00' }" type="delete" />
						</div>
					</div>
				</div>
				<div>
					<!-- Required validation -->
					<div v-if="requiredBrand&&brandsData.length == 0" style="color: #f00;font-size: 14px;"
						class="factory">请填写筛选项</div>
					<!--  -->
					<div v-if="lessThanTwoBrand&&brandsData.length < 2" style="color: #f00;font-size: 14px;"
						class="factory">至少添加2个筛选项</div>
				</div>
			</a-col>
		</a-row>
		<a-row>
			<a-col :span="20" style="text-align: center;">
				<a-button style="width: 200px;height: 40px;" type="primary" @click="submit">保存</a-button>
			</a-col>
		</a-row>
	</div>
</template>
<script>
	import Sortable from 'sortablejs'
	import {
		getTagCategoriesApi,
		getIndexSearchApi,
		updateIndexSearchApi,
		// getOssAuth,
	} from "../../api/index";
	export default {
		name: "countryList",
		data() {
			return {
				factoryData: [],
				brandsData: [],
				factoryList: [],
				brandsList: [],
				sortable: null, // 拖拽实例
				filterData: {
					factoryId: undefined,
					brandId: undefined,
				},
				requiredFactory: false,
				lessThanTwoFactory: false,
				requiredBrand: false,
				lessThanTwoBrand: false
			};
		},
		created() {},
		activated() {},
		mounted() {
			// 初始化拖拽
			this.initDrag();
			this.initDragBrand();

			// 下拉框数据
			this.getDataFactory()
			this.getDataBrand()


			this.getData()
		},
		beforeRouteLeave(to, from, next) {
			localStorage.setItem('homepage_searchQuery', JSON.stringify(this.filterData));
			next();
		},
		methods: {
			initDragBrand() {
				const el = this.$refs.dragContainerBrand
				if (!el) return
				this.sortable = Sortable.create(el, {
					animation: 150, // 流畅动画
					handle: '.size_item', // 可拖拽元素
					draggable: '.size_item',
					forceFallback: false,
					ghostClass: 'sort-ghost',

					// 拖拽结束
					onEnd: (evt) => {
						const {
							oldIndex,
							newIndex
						} = evt
						// 数组顺序同步（核心！）
						const moveItem = this.brandsData.splice(oldIndex, 1)[0]
						this.brandsData.splice(newIndex, 0, moveItem)
					},
				})
			},
			initDrag() {
				const el = this.$refs.dragContainer
				if (!el) return
				this.sortable = Sortable.create(el, {
					animation: 150, // 流畅动画
					handle: '.size_item', // 可拖拽元素
					draggable: '.size_item',
					forceFallback: false,
					ghostClass: 'sort-ghost',

					// 拖拽结束
					onEnd: (evt) => {
						const {
							oldIndex,
							newIndex
						} = evt
						// 数组顺序同步（核心！）
						const moveItem = this.factoryData.splice(oldIndex, 1)[0]
						this.factoryData.splice(newIndex, 0, moveItem)
					},
				})
			},
			deletePaperSizeBrand(index) {
				this.brandsData.splice(index, 1);
			},
			deletePaperSizeFactory(index) {
				this.factoryData.splice(index, 1);
			},
			addFactory() {
				if (this.filterData.factoryId === 'AREA') {
					const hasArea = this.factoryData.some(item => item.searchType === 'AREA');
					if (hasArea) {
						this.$message.warning('已添加过区域');
						return;
					}
					this.factoryData.push({
						searchType: 'AREA',
						tagCategoryName: '区域'
					});
					this.filterData.factoryId = undefined;
					return;
				}
				const hasFactory = this.factoryData.some(item => item.tagCategoryId == this.filterData.factoryId);
				if (hasFactory) {
					this.$message.warning('已添加过该工厂');
					return;
				} else {
					const factory = this.factoryList.find(item => item.tagCategoryId == this.filterData.factoryId);
					if (factory) {
						this.factoryData.push(factory);
						this.filterData.factoryId = undefined;
					}
				}
			},
			addBrand() {
				const hasBrand = this.brandsData.some(item => item.tagCategoryId == this.filterData.brandId);
				if (hasBrand) {
					this.$message.warning('已添加该品牌');
					return;
				} else {
					const brand = this.brandsList.find(item => item.tagCategoryId == this.filterData.brandId);
					if (brand) {
						this.brandsData.push(brand);
						this.filterData.brandId = undefined;
					}
				}
			},
			handleFocus() {
				console.log('focus');
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},

			getData() {
				if (this.loading) {
					return;
				}
				this.loading = true;
				getIndexSearchApi({})
					.then((res) => {
						if (res.resultStatus) {
							this.factoryData = res.resultData.factories || [];
							this.brandsData = res.resultData.brands || [];
						} else {
							this.factoryData = [];
							this.brandsData = [];
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			submit() {
				this.requiredFactory = this.factoryData.length == 0;
				this.requiredBrand = this.brandsData.length == 0;
				this.lessThanTwoFactory = this.factoryData.length > 0 && this.factoryData.length < 2
				this.lessThanTwoBrand = this.brandsData.length > 0 && this.brandsData.length < 2
				if (this.factoryData.length == 0) {

					this.$message.error('请填写筛选项');
					return;
				}
				if (this.brandsData.length == 0) {

					this.$message.error('请填写筛选项');
					return;
				}
				if (this.factoryData.length > 0 && this.factoryData.length < 2) {

					this.$message.error('至少添加2个筛选项');
					return;
				}
				if (this.brandsData.length > 0 && this.brandsData.length < 2) {

					this.$message.error('至少添加2个筛选项');
					return;
				}


				console.log('submit', this.factoryData, this.brandsData);
				let arr1 = this.factoryData.map(item => {
					const newItem = {};
					// 只保留你需要的3个，且值不为空才加
					if (item.searchType) newItem.searchType = item.searchType;
					if (item.tagCategoryId) newItem.tagCategoryId = item.tagCategoryId;
					if (item.tagCategoryName) newItem.tagCategoryName = item.tagCategoryName;
					return newItem;
				});
				let arr2 = this.brandsData.map(item => {
					const newItem = {};
					// 只保留你需要的3个，且值不为空才加
					if (item.searchType) newItem.searchType = item.searchType;
					if (item.tagCategoryId) newItem.tagCategoryId = item.tagCategoryId;
					if (item.tagCategoryName) newItem.tagCategoryName = item.tagCategoryName;
					return newItem;
				});
				// 提交接口
				updateIndexSearchApi({
						"factories": arr1,
						"brands": arr2,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success(
								'保存成功'
							);
							this.editModel.flag = false;
						} else {
							this.$message.error(
								res.errorMessage
							);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.getData()
					})
			},

			getDataFactory() {
				getTagCategoriesApi({
						tagTypeCategory: 'FACTORY'
					})
					.then((res) => {
						if (res.resultStatus) {
							this.factoryList = res.resultData
						} else {
							this.factoryList = [];
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			getDataBrand() {
				getTagCategoriesApi({
						tagTypeCategory: 'BRAND'
					})
					.then((res) => {
						if (res.resultStatus) {
							this.brandsList = res.resultData
						} else {
							this.brandsList = [];
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},

		},
	};
</script>

<style lang="less">
	.container_page {
		background: #fff;
		padding: 20px;

		.title {
			font-size: 18px;
			font-weight: 700;
			margin-bottom: 16px;
		}

		.titleSu {
			font-size: 16px;
			padding-left: 10px;
		}

		.size_item {
			min-height: 50px;
			background: #f7f7f7;
			display: flex;
			align-content: center;
			justify-content: space-between;
			margin-bottom: 4px;
			margin-top: 4px;
			cursor: move;
			padding: 0 10px;


			.left {
				width: calc(100% - 50px);
				line-height: 50px;
				padding-left: 20px;
			}

			.right {
				width: 50px;
				line-height: 50px;
				text-align: center;
				cursor: pointer;
			}
		}

	}

	.ant-select-selection--single {
		height: 35px !important;
	}
</style>
